(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["youtube-feed"]) return;
  try {
    
var flkty = new Flickity('#youtubeFlickity', {
  cellAlign: 'left',
  contain: true,
  pageDots: false,
  freeScroll: true,
  wrapAround: true,
  prevNextButtons:false
});

  } catch(e) { console.error(e); }
})();
})();
